module.exports = __webpack_public_path__ + "static/media/risk-assessment-blue.e84db728.svg";